var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListProperty',{attrs:{"property":_vm.property,"action":_vm.action,"disable":_vm.disable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }